module.exports = __webpack_public_path__ + "img/26.6c2bbf4c.jpg";